export default [
  // 签约居民列表
  {
    name: 'defaultFamilyDoctorList',
    path: 'familyDoctorList',
    component: () => import(/* webpackChunkName: 'defaultFamilyDoctorList' */ '../views/familyDoctorModule/list/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultFamilyDoctorList',
    },
  },
  // 签约居民管理 - 详情
  {
    name: 'defaultFamilyDoctorDetail',
    path: 'familyDoctorDetail',
    component: () => import(
      /* webpackChunkName: 'defaultFamilyDoctorDetail'  */
      '../views/familyDoctorModule/patientDetails/index.vue'),
    meta: {
      tabGroup: 'defaultFamilyDoctorList',
    },
  },
  // 家医分组管理
  {
    name: 'defaultFamilyDoctorGroup',
    path: 'familyDoctorGroup',
    component: () => import(/* webpackChunkName: 'defaultFamilyDoctorGroup' */ '../views/familyDoctorModule/list/group.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultFamilyDoctorGroup',
    },
  },
  // 家医收藏管理
  {
    name: 'defaultFamilyDoctorFavorite',
    path: 'familyDoctorFavorite',
    component: () => import(/* webpackChunkName: 'defaultFamilyDoctorFavorite' */ '../views/familyDoctorModule/list/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultFamilyDoctorFavorite',
    },
  },
  // 家医消息下发
  {
    name: 'defaultFamilyDoctorMessage',
    path: 'familyDoctorMessage',
    component: () => import(/* webpackChunkName: 'defaultFamilyDoctorMessage' */ '../views/familyDoctorModule/list/message.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultFamilyDoctorMessage',
    },
  },
];
